import React, { useEffect, useState } from "react";
import find from "lodash/find";
import ReactDatePicker from "react-datepicker";
import { User, Calendar, X } from "react-feather";
import Modal from "react-modal";
import ModalContent from "../../common/Modal/ModalContent";
import moment from "moment";
import api from "../../utils/api";
import close_modal from "./../../assets/ic_close_modal_depre.svg";
import MultiSelectAll from "../../common/Multiselect/MultiSelectAll";
import Select from "react-select";
import SelectServiceStatusDropdown from "./SelectServiceStatusDropdown";
import { ControlledInput } from "../../common/Input/Input";
import Checkbox from "../../common/Checkbox/Checkbox";

export default function DePreneurListingModal(props) {

  return (
    <Modal
      isOpen={props.isOpen}
      onRequestClose={props.toggleModal}
      ariaHideApp={false}
    >
      <ModalContent className="depreneur-details-modal">
          <div className="modal-header-sp">
          <span className="modal-title">dePreneur Listing Details</span>
            <img
                alt="close"
                id="Close"
                src={close_modal}
                className="close modal-close"
                onClick={props.toggleModal}
            />
          </div>
        
        <div
            className={`modal-body spled-container notes-trail-content depreneur-filter-content custom-scrollbar`}
        >
            {props.selectedServiceRequestBusinessDetails.sImageUrl?
                (
                <>
                    <div className="conv-mt10 conv-mb10" style={{textAlign:"center"}}>
                        <div className="image-cropper">
                            <img
                                alt={"Icon"}
                                src={props.selectedServiceRequestBusinessDetails.sImageUrl||""}
                                className="cursor-pointer"
                                style={{height:"70px"}}
                            />
                        </div>
                    </div>
                    
                    {/*<div className="image-cropper">
                        <img
                            alt={"Icon"}
                            src={props.selectedServiceRequestBusinessDetails.sImageUrl||""}
                            className="cursor-pointer"
                            style={{height:"70px"}}
                        />
                    </div>*/}
                    <div style={{clear:"both"}}></div>
                    <div className="depreneur-modal-name"  style={{marginTop:"10px", textAlign:"center"}}>
                    {props.selectedServiceRequestBusinessDetails.sFirstName} {props.selectedServiceRequestBusinessDetails.sLastName}
                    </div>
                    <div style={{clear:"both"}}></div>

                    <div className="row conv-mt15 conv-pr10 conv-pl10">
                        <div className="col-5 conv-mt20">
                            <div className="dePreneur-modal-lable">
                                Business Name:
                            </div>
                        </div>
                        <div className="col-7 conv-mt20">
                            <div className="dePreneur-modal-lable-value" style={{overflowWrap:"break-word"}}>
                            {props.selectedServiceRequestBusinessDetails.sBusinessName}
                            </div>
                        </div>

                        <div style={{clear:"both"}}></div>
                        <div className="col-5 conv-mt20">
                            <div className="dePreneur-modal-lable">
                            Business Sector:
                            </div>
                        </div>
                        <div className="col-7 conv-mt20">
                            <div className="dePreneur-modal-lable-value" style={{overflowWrap:"break-word"}}>
                            {props.selectedServiceRequestBusinessDetails.sBusinessSector}
                            </div>
                        </div>

                        <div style={{clear:"both"}}></div>
                        <div className="col-5 conv-mt20">
                            <div className="dePreneur-modal-lable" >
                                Pin Code:
                            </div>
                        </div>
                        <div className="col-7 conv-mt20">
                            <div className="dePreneur-modal-lable-value" style={{overflowWrap:"break-word"}}>
                            {props.selectedServiceRequestBusinessDetails.pincode}
                            </div>
                        </div>
                    </div>     
                    <div className="row conv-mt25 dePreneur-Update-box conv-pb10">
                        <div className="col-12 conv-mr0 depreneur-middle-header-sp conv-text-center">
                            <span className="modal-middle-title">Update dePreneur Listing Details</span>                            
                        </div>  
                        <div className="col-12 conv-mt20">
                            <span className="depreneur-update-text">Business Name</span>
                            <ControlledInput
                                placeholder="Business Name"
                                name="sBusinessName"
                                lable="Business Name"
                                value={props.selectedServiceRequestBusinessDetailsForEdit.sBusinessName}
                                autoComplete="off"
                                onChange={(e) =>{	
                                    props.onBusinessDetailsChange(e.target.name, e.target.value);
                                }}
                                disabled={props.selectedServiceRequestBusinessDetailsForEdit.custrefSRState==="Cancelled"||props.selectedServiceRequestBusinessDetailsForEdit.custrefSRState==="Delivered"||props.selectedServiceRequestBusinessDetails.is_business_verified==='Yes'||props.isForAdmin}
                            />
                        </div>
                        <div className="col-12 conv-mt10 depreneur-checkbox">
                            <Checkbox
                                id={`checkbox-handled`}
                                checked={props.selectedServiceRequestBusinessDetailsForEdit.is_business_verified==='Yes' || false}
                                onChange={(e) => {
                                    e.stopPropagation();
                                    props.onBusinessDetailsChange(
                                        "is_business_verified",
                                        props.selectedServiceRequestBusinessDetailsForEdit.is_business_verified==='Yes'?('No'):('Yes')
                                    );
                                }}
                                label={"Mark As Verified"}
                                disabled={props.selectedServiceRequestBusinessDetailsForEdit.custrefSRState==="Cancelled"||props.selectedServiceRequestBusinessDetailsForEdit.custrefSRState==="Delivered"||props.selectedServiceRequestBusinessDetails.is_business_verified==='Yes'||props.isForAdmin}
                            ></Checkbox>
                        </div>
                        <div className="col-12 conv-mt20 conv-text-center ">
                        {props.selectedServiceRequestBusinessDetailsForEdit.custrefSRState=="Cancelled"||props.selectedServiceRequestBusinessDetailsForEdit.custrefSRState=="Delivered"||props.selectedServiceRequestBusinessDetails.is_business_verified==='Yes'||props.isForAdmin?
                        (
                            <button 
                                type="button" 
                                style={{cursor:"not-allowed"}}
                                className="con-btn-filled conv-pr35 conv-pl35 disabled"
                                >
                                Update
                            </button>
                        ):
                        (
                            <button 
                                type="button" 
                                className="con-btn-filled conv-pr35 conv-pl35 disabled"
                                onClick={props.ondePreneurDetailsUpdate}
                            >
                                Update
                            </button>
                        )} 
                            
                        </div>
                    </div>                                           
                </>                
            ):
            (
                <div className="row conv-mt15 conv-mb15 conv-pr10 conv-pl10">
                    <div className="col-12 conv-mt20 conv-mb20">
                        <div className="dePreneur-modal-lable">
                            No records available
                        </div>
                    </div>
                </div>                
            )}
        </div>
      </ModalContent>
    </Modal>
  );
}